import { fetchOrder } from "../../../../../services/orderService";
import { fetchProductionsByOrderId } from "../../../../../services/productionService";

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getSupplyMaterialId = (supply) =>
  supply?.materialId ?? supply?.Material?.id ?? null;

export const countShippedMaterialQuantity = (
  shippedProductions = [],
  materialId,
) => {
  if (materialId === null || materialId === undefined) {
    return 0;
  }

  return shippedProductions.filter(
    (production) => Number(production?.materialId) === Number(materialId),
  ).length;
};

export const calculateBackorderQuantity = (
  supply,
  shippedProductions = [],
) => {
  const materialId = getSupplyMaterialId(supply);
  const orderedQuantity = toNumber(supply?.quantity);
  const shippedQuantity = countShippedMaterialQuantity(
    shippedProductions,
    materialId,
  );

  return orderedQuantity - shippedQuantity;
};

export const formatBackorderQuantity = (
  backorderQuantity,
  completeLabel = "Complete",
) => (backorderQuantity > 0 ? backorderQuantity : completeLabel);

export const getBackorderDisplayValue = (
  supply,
  shippedProductions = [],
  completeLabel = "Complete",
) =>
  formatBackorderQuantity(
    calculateBackorderQuantity(supply, shippedProductions),
    completeLabel,
  );

export const calculateOrderBackorderQuantities = (
  order,
  shippedProductions = [],
) => {
  const supplies = Array.isArray(order?.Supplies) ? order.Supplies : [];

  return supplies.map((supply) => ({
    materialId: getSupplyMaterialId(supply),
    backorderQuantity: calculateBackorderQuantity(supply, shippedProductions),
  }));
};

export const shouldOrderBeBackorder = (order, shippedProductions = []) =>
  calculateOrderBackorderQuantities(order, shippedProductions).some(
    ({ backorderQuantity }) => backorderQuantity > 0,
  );

export const shouldOrderBeBackorderById = async (orderId) => {
  const [order, shippedProductions] = await Promise.all([
    fetchOrder(orderId),
    fetchProductionsByOrderId(orderId),
  ]);

  return shouldOrderBeBackorder(order, shippedProductions);
};
